interface SupplyChainPricingMap {
  [key: string]: {
    [key: string]: number;
  };
}

export function getSupplyChainPricing() {
  const map: SupplyChainPricingMap = {
    tampons: {
      GBP: 0.1,
      EUR: 0.12,
      USD: 0.14
    },
    sanitisation: {
      GBP: 0.01,
      EUR: 0.01,
      USD: 0.01
    },
    cbd: {
      GBP: 0.15,
      EUR: 0.17,
      USD: 0.21
    },
    testing: {
      GBP: 0.02,
      EUR: 0.02,
      USD: 0.03
    },
    packaging: {
      GBP: 0.08,
      EUR: 0.09,
      USD: 0.11
    },
    cargo: {
      GBP: 0.05,
      EUR: 0.06,
      USD: 0.07
    },
    labour: {
      GBP: 0.09,
      EUR: 0.11,
      USD: 0.12
    },
    trueCostNaked: {
      GBP: 0.35,
      EUR: 0.41,
      USD: 0.48
    },
    trueCostCBD: {
      GBP: 0.5,
      EUR: 0.58,
      USD: 0.69
    },
    consumerNaked: {
      GBP: 0.465,
      EUR: 0.562,
      USD: 0.7
    },
    consumerCBD: {
      GBP: 0.88,
      EUR: 1.03,
      USD: 1.21
    }
  };
  return map;
}
